<template>
    <div class="c-calendar">
            <vc-calendar class="c-calendar__datepicker"
                :attributes="attributes"
                :disabled-dates='{ weekdays: [1, 7] }'
                :min-date="startDate"
                @dayclick="selectDate"
            />
            <div class="c-calendar__dayTime">
                <p>
                    Wybierz preferowaną
                    <br>
                    porę dnia:
                </p>
                <label v-for="timeOfDay in timesOfday">
                    <input type="checkbox" :value="timeOfDay.name" class="c-calendar__dayTimeItem" v-on:click="selectTimeOfDay(timeOfDay.name)"> {{timeOfDay.name}}
                </label>
            </div>
            <BottomBar :hidden="isTryingToSelectWeekend">
                Nasz Serwis jest nieczynny w weekendy, prosimy o wskazanie innego dogodnego terminu wizyty.
            </BottomBar>
    </div>
</template>
<script>
import BottomBar from './BottomBar'

export default {
    components:{
        BottomBar
    },
    data(){
        return {
            days: [],
            selectedDate:null,
            selectedTimeOfDay:null,
            isTryingToSelectWeekend:false,
            timesOfday:[
                {
                    id:0,
                    name: 'Rano'
                },
                {
                    id:0,
                    name: 'Południe'
                },
                {
                    id:0,
                    name: 'Wieczór'
                }
            ]
        }
    },
    computed:{
        startDate: {
            get(){
                let date = new Date(); 
                return date.setDate(date.getDate() + 1)
            }
        },
        dates() {
            return this.days.map(day => day.date);
        },
        attributes() {
            return this.dates.map(date => ({
                highlight: true,
                dates: date,
            }));
        },
        isValid() {
            return !!this.selectedDate && !!this.selectedTimeOfDay
        }
    },
    methods:{
        selectDate(day){
            if(day.weekday == 1 || day.weekday == 7){
                console.log('weekend');
                this.isTryingToSelectWeekend = true;
                return;
            }else if(day.isDisabled){
                console.log('disabled');
                this.isTryingToSelectWeekend = false;
                return;
            }else{
                this.isTryingToSelectWeekend = false;
            }
            const idx = this.days.findIndex(d => d.id === day.id);
            if (idx >= 0) {
                this.days.splice(idx, 1);
                this.selectedDate = null;
            } else {
                this.days = [{
                id: day.id,
                date: day.date,
                }];

                this.selectedDate = day.ariaLabel;
            }
            this.$emit('selectDate',this.selectedDate);
            this.$emit('isValid',this.isValid);
        },
        selectTimeOfDay(time){
            if(this.selectedTimeOfDay == time){
                this.selectedTimeOfDay = null;
            }else{
                this.selectedTimeOfDay = time;
            }
            this.$emit('selectTimeOfDay',this.selectedTimeOfDay);
            this.$emit('isValid',this.isValid);
        }
    }
}
</script>
<style lang="scss">
    @import '../_variables.scss';
    .c-calendar{
        @media(min-width: 780px){
            display: flex;
            justify-content: space-between;
        }
        &__datepicker{
           width:100% !important;
           max-width: 620px;
            border-radius: 1.5rem !important;
            border: 1px solid $gray im !important;
           .vc-day-content{
               font-weight: bold !important;
               font-size: 1rem !important;
           }
           .vc-header{
               max-width:235px;
               margin: 0 auto;
           }
           .vc-arrows-container{
               max-width:235px;
               margin: 0 auto;
               left: 0;
                right: 0;
                top: 1rem;
           }
           .vc-title{
               font-weight: bold !important;
               padding: 1rem !important;
               font-size: 1.5rem !important;
           }
           .vc-weeks{
               border-top: 1px solid $gray;
               padding: 1rem !important;
           }
        }
        &__dayTime{
                width: 100%;
                padding: 2rem;
                display: flex;
                flex-direction: column;
                justify-content: center;
        }
        &__dayTimeItem{
            margin: .5rem 0;
        }
    }
</style>